<p-tabView>
  <p-tabPanel header="Sales Dashboard">
    <app-crm-stats></app-crm-stats>
  </p-tabPanel>
  <p-tabPanel header="Sales Leads">
    <app-crm-leads-dashboard></app-crm-leads-dashboard>
  </p-tabPanel>
</p-tabView>
